export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        stroke="#6B7B8C"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M17.5 17.5l-5-5m1.667-4.167a5.833 5.833 0 11-11.666 0 5.833 5.833 0 0111.666 0z"
      ></path>
    </svg>
  );
};

export const FacebookIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
      ></path>
      <path
        fill="#FEFEFE"
        d="M18 12c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 3 2.175 5.475 5.025 5.925v-4.2h-1.5V12h1.5v-1.35c0-1.5.9-2.325 2.25-2.325.675 0 1.35.15 1.35.15v1.5h-.75c-.75 0-.975.45-.975.9V12h1.65l-.3 1.725h-1.425V18c3-.45 5.175-3 5.175-6z"
      ></path>
    </svg>
  );
};

export const LinkedInIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
      ></path>
      <path
        fill="#FEFEFE"
        d="M8.7 18H6.15V9.975H8.7V18zM7.425 8.85C6.6 8.85 6 8.25 6 7.425 6 6.6 6.675 6 7.425 6c.825 0 1.425.6 1.425 1.425 0 .825-.6 1.425-1.425 1.425zM18 18h-2.55v-4.35c0-1.275-.525-1.65-1.275-1.65-.75 0-1.5.6-1.5 1.725V18h-2.55V9.975h2.4V11.1c.225-.525 1.125-1.35 2.4-1.35 1.425 0 2.925.825 2.925 3.3V18H18z"
      ></path>
    </svg>
  );
};

export const YouTubeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
      ></path>
      <path
        fill="#FEFEFE"
        d="M17.7 9.075c-.15-.525-.525-.9-1.05-1.05-.9-.225-4.725-.225-4.725-.225s-3.75 0-4.725.225c-.525.15-.9.525-1.05 1.05C6 10.05 6 12 6 12s0 1.95.225 2.925c.15.525.525.9 1.05 1.05.9.225 4.725.225 4.725.225s3.75 0 4.725-.225c.525-.15.9-.525 1.05-1.05C18 13.95 18 12 18 12s0-1.95-.3-2.925zM10.8 13.8v-3.6l3.15 1.8-3.15 1.8z"
      ></path>
    </svg>
  );
};

export const InstagramIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12S18.627 0 12 0 0 5.373 0 12z"
      ></path>
      <path
        fill="#FEFEFE"
        d="M12 6.9h2.55c.6 0 .9.15 1.125.225.3.15.525.225.75.45.225.225.375.45.45.75.075.225.15.525.225 1.125v5.1c0 .6-.15.9-.225 1.125-.15.3-.225.525-.45.75-.225.225-.45.375-.75.45-.225.075-.525.15-1.125.225h-5.1c-.6 0-.9-.15-1.125-.225-.3-.15-.525-.225-.75-.45-.225-.225-.375-.45-.45-.75-.075-.225-.15-.525-.225-1.125V12 9.45c0-.6.15-.9.225-1.125.15-.3.225-.525.45-.75.225-.225.45-.375.75-.45.225-.075.525-.15 1.125-.225H12zm0-1.125H9.45c-.675 0-1.125.15-1.5.3s-.75.375-1.125.75-.525.675-.75 1.125c-.15.375-.225.825-.3 1.5v5.1c0 .675.15 1.125.3 1.5s.375.75.75 1.125.675.525 1.125.75c.375.15.825.225 1.5.3h5.1c.675 0 1.125-.15 1.5-.3s.75-.375 1.125-.75.525-.675.75-1.125c.15-.375.225-.825.3-1.5V12 9.45c0-.675-.15-1.125-.3-1.5a3.275 3.275 0 00-.75-1.125c-.375-.375-.675-.525-1.125-.75-.375-.15-.825-.225-1.5-.3H12z"
      ></path>
      <path
        fill="#FEFEFE"
        d="M12 8.775A3.201 3.201 0 008.775 12c0 1.8 1.425 3.225 3.225 3.225S15.225 13.8 15.225 12 13.8 8.775 12 8.775zm0 5.325c-1.125 0-2.1-.9-2.1-2.1 0-1.125.9-2.1 2.1-2.1 1.125 0 2.1.9 2.1 2.1 0 1.125-.975 2.1-2.1 2.1zM15.3 9.45a.75.75 0 100-1.5.75.75 0 000 1.5z"
      ></path>
    </svg>
  );
};
